var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon360Facility(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon360_Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 239.8 49.7",
    style: {
      enableBackground: "new 0 0 239.8 49.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.icon360-st0{fill:#205A8E;}\n\t.icon360-st1{fill:#00458D;}\n\t.icon360-st2{fill:#12274C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon360-st0",
    d: "M45.2,38.2c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c-0.1-0.9-0.4-1.8-0.9-2.7l-0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3 L33.3,16.2c-0.2,0.6-0.5,1.2-0.8,1.8l-7.6,13.1l6.5,11.3c1.2,2.1,3.4,3.4,5.7,3.6h0.7c3.5,0,6.5-2.5,7.2-5.9c0,0,0,0,0,0 c0-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C45.2,38.5,45.2,38.3,45.2,38.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon360-st1",
    d: "M16.4,16.4l6.4,11.1l6.4-11.1c1.9-3.3,1-7.5-2-9.6c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3 c-0.1-0.1-0.2-0.1-0.3-0.2C26.2,6.1,26.1,6.1,26,6c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.3-0.1-0.5-0.2 c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5-0.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.3,0-0.4,0 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0-0.5,0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.4,0.1-0.5,0.1c-0.1,0-0.1,0-0.2,0 c-0.2,0-0.3,0.1-0.5,0.2c-0.1,0-0.1,0-0.2,0.1C20,5.9,19.8,6,19.7,6c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2 c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0-0.1,0.1-0.2,0.1C15.5,8.9,14.6,13.1,16.4,16.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M0.4,38.2c0-0.1,0-0.3,0-0.4c0,0,0-0.1,0-0.1c0.1-0.9,0.4-1.8,0.9-2.7l0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3 l10.6-18.3c0.2,0.6,0.5,1.2,0.8,1.8l7.6,13.1l-6.5,11.3c-1.2,2.1-3.4,3.4-5.7,3.6H7.8c-3.5,0-6.5-2.5-7.2-5.9c0,0,0,0,0,0 c0-0.2-0.1-0.4-0.1-0.6c0-0.1,0-0.1,0-0.2c0-0.2,0-0.3,0-0.5c0-0.1,0-0.2,0-0.3C0.4,38.5,0.4,38.3,0.4,38.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M63.3,15c4.6,0,7,2.6,7,5.9c0,2.8-1.8,4.4-3.3,4.9v0.1c2.2,0.7,3.6,2.4,3.6,5.2c0,3.6-2.6,6.2-7.1,6.2 c-4.5,0-7.8-2.1-7.9-7h4.9c0,1.7,0.9,2.8,2.8,2.8c1.6,0,2.4-1,2.4-2.4c0-1.9-1.2-2.7-3.8-2.7h-0.9v-4.1H62c1.7,0,3.4-0.4,3.4-2.4 c0-1.5-0.9-2.2-2.2-2.2c-1.6,0-2.2,1.2-2.3,2.4h-4.9C56.1,17.3,58.9,15,63.3,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M83.2,21.3c-0.3-1.4-1-2.2-2.5-2.2c-2.3,0-3.2,1.9-3.2,6.1c0.9-1.4,2.6-2.2,4.6-2.2c3.8,0,6.4,2.5,6.4,7 c0,4.3-2.7,7.3-7.4,7.3c-6.5,0-8.1-4.6-8.1-11.1c0-7.4,2.3-11.1,7.9-11.1c4.6,0,6.7,3.1,7,6.3H83.2z M77.9,29.9c0,1.9,1.1,3,3,3 c1.7,0,2.8-1.1,2.8-2.9c0-1.8-1-3-2.9-3C79.2,27,77.9,28,77.9,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M99.1,15.1c6.2,0,8.3,4.6,8.3,11c0,6.4-2.2,11-8.3,11s-8.3-4.6-8.3-11C90.8,19.7,92.9,15.1,99.1,15.1z  M99.1,19.8c-3,0-3.3,2.9-3.3,6.2c0,3.4,0.4,6.3,3.3,6.3s3.3-2.8,3.3-6.3C102.4,22.7,102.1,19.8,99.1,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M110.6,16.3h13.5v4.1h-8.5v4.4h6.3v3.9h-6.3v8.4h-5.1V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M137.9,33.4h-7.8l-1.2,3.7h-5.3l7.5-20.8h5.9l7.5,20.8h-5.4L137.9,33.4z M134,21.9l-2.5,7.6h5.1L134,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M155.2,16.1c4.9,0,8.7,2.8,9.9,7.3h-5.6c-0.9-1.8-2.4-2.7-4.4-2.7c-3.1,0-5.2,2.3-5.2,6c0,3.7,2.1,6,5.2,6 c1.9,0,3.5-0.9,4.4-2.7h5.6c-1.2,4.5-4.9,7.3-9.9,7.3c-6.1,0-10.4-4.4-10.4-10.6C144.7,20.5,149.1,16.1,155.2,16.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M168.2,16.3h5.1v20.8h-5.1V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M182,16.3v16.9h6.6v3.9h-11.7V16.3H182z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M191,16.3h5.1v20.8H191V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M198.6,16.3h16.1v4.1h-5.5v16.7h-5.1V20.4h-5.5V16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon360-st2",
    d: "M215.6,16.3h5.7l4,8.7l4-8.7h5.7l-7.2,13.9v6.9h-5.1v-6.9L215.6,16.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon360Facility);
export default __webpack_public_path__ + "static/media/Icon360Facility.8ef7db02.svg";
export { ForwardRef as ReactComponent };